module.exports = __webpack_public_path__ + "assets/logout.b8c42307.svg";